module.exports = __webpack_public_path__ + "packs/media/images/Meet_Active-13f39a6e3d9758bec34f8d073ca1d458.svg";